"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _withDefaults = _interopRequireDefault(require("./with-defaults"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  width: 24,
  height: 24,
  plain: false,
  className: ''
};

const Close = ({
  size,
  fill,
  plain,
  width,
  height,
  className,
  ...props
}) => {
  if (plain) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
      width: size || width,
      height: size || height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: fill,
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: className,
      ...props,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18 6L6 18M6 6l12 12"
      })
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: size || width,
    height: size || height,
    viewBox: "0 0 24 24",
    className: className,
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12 2a10 10 0 1010 10A10.016 10.016 0 0012 2zm3.36 12.3a.754.754 0 010 1.06.748.748 0 01-1.06 0l-2.3-2.3-2.3 2.3a.748.748 0 01-1.06 0 .754.754 0 010-1.06l2.3-2.3-2.3-2.3A.75.75 0 019.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 011.06 1.06l-2.3 2.3z",
      fill: fill
    })
  });
};

const MemoClose = /*#__PURE__*/React.memo(Close);

var _default = (0, _withDefaults.default)(MemoClose, defaultProps);

exports.default = _default;
module.exports = exports.default;